if ($("footer#footer").length) {
  $('.copyright').html($('.copyright').html().replace('Copyright', 'Copyright 2002 - '))
  if ($(".in-index").length) {
    $("footer#footer").before($("footer#footer .repas"));
    $(".homepage-blog-wrapper").replaceWith($("footer#footer .customBlog"));
  }
  $(".newsletter-header").before($("footer#footer .newsletterTitle"));
  $("footer#footer").before($("footer#footer .shopRatings"));
  $('#formNewsletterWidget input[type="email"]').attr(
    "placeholder",
    translation("vasEmail"),
  );
  $('#formNewsletterWidget button[type="submit"]').text(
    translation("odebiratnewsletter"),
  );
  $("footer#footer .helpFooter .right ul").append(
    $("footer#footer .contact-box span.tel").closest("li").clone(),
    $("footer#footer .contact-box span.mail").closest("li").clone(),
  );
  $(".fanAndCertifikate ul.fanList").append(
    $("footer#footer .contact-box span.facebook").closest("li").clone(),
    $("footer#footer .contact-box span.instagram").closest("li").clone(),
    $("footer#footer .contact-box span.youtube").closest("li").clone(),
    $("footer#footer .contact-box span.tiktok").closest("li").clone(),
  );
}

$("html").on("click", ".custom-footer>div h5", function () {
  $(this).next(".mobileOpen").toggleClass("openIt");
  $(this).toggleClass("openTitle");
});
